
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sykler/bestill/[bikeId]",
      function () {
        return require("private-next-pages/sykler/bestill/[bikeId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sykler/bestill/[bikeId]"])
      });
    }
  